// Orb — the workspace's pulse. Layered conic gradients rotate through a registered
// custom property (@property --orb-a), a blurred halo breathes behind them, and the speed
// and palette follow the state: asleep (still, dim), waking/starting (slow indigo→teal
// swirl), connecting (faster), thinking (fast, violet), error (red). CSS only; paused
// under prefers-reduced-motion. Styles live in ui.css.

import { h } from 'preact';

export const PHASE_TEXT = {
  preparing: 'Getting ready…',
  waking: 'Waking your workspace…',
  starting: 'Starting your workspace…',
  connecting: 'Connecting to the agent…',
  thinking: 'Thinking…',
};

export function Orb({ state = 'idle', size = 28, label }) {
  return h('span', {
    className: 'orb',
    'data-state': state,
    style: { '--orb-size': `${size}px` },
    role: label ? 'img' : undefined,
    'aria-label': label || undefined,
    'aria-hidden': label ? undefined : 'true',
  }, h('span', { className: 'orb-core' }), h('span', { className: 'orb-glint' }));
}

// The assistant's placeholder before the first token: orb + stage line, and after 20 s an
// honest "this can take a minute".
export function PhaseLine({ phase, elapsed = 0 }) {
  const text = PHASE_TEXT[phase] || 'Working…';
  const slow = (phase === 'waking' || phase === 'starting') && elapsed >= 20;
  const orbState = phase === 'thinking' ? 'thinking' : phase === 'connecting' ? 'connecting' : 'waking';
  return h('div', { className: 'phase-line', role: 'status' },
    h(Orb, { state: orbState, size: 34 }),
    h('div', { className: 'phase-text' },
      h('span', { className: 'phase-main shimmer' }, text),
      slow ? h('span', { className: 'phase-sub' }, 'Still waking. A workspace that slept can take up to a minute.') : null));
}
